import { Popover as PopoverPrimitive } from 'radix-ui';
import type * as React from 'react';

import { cn } from '@/lib/utils';

const Popover = ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Root>) => {
  return <PopoverPrimitive.Root data-slot='popover' {...props} />;
};

const PopoverTrigger = ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Trigger>) => {
  return <PopoverPrimitive.Trigger data-slot='popover-trigger' {...props} />;
};

const PopoverAnchor = ({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Anchor>) => {
  return <PopoverPrimitive.Anchor data-slot='popover-anchor' {...props} />;
};

const PopoverContent = ({
  className,
  align = 'start',
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) => {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot='popover-content'
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'tw:z-50',
          'tw:w-auto',
          'tw:rounded-xl',
          'tw:bg-popover',
          'tw:p-4',
          'tw:text-sm',
          'tw:text-popover-foreground',
          'tw:ring-1',
          'tw:ring-foreground/10',
          'tw:shadow-lg',
          'tw:duration-100',
          'tw:outline-none',
          'tw:data-open:animate-in',
          'tw:data-open:fade-in-0',
          'tw:data-open:zoom-in-95',
          'tw:data-closed:animate-out',
          'tw:data-closed:fade-out-0',
          'tw:data-closed:zoom-out-95',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
};

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
